import { createRoot } from 'react-dom/client';
import { configureHoneybadger, notifyCaughtRenderError } from './Honeybadger';
import { reloadOnConsentWithdrawal, removeDeniedCookies } from './Osano';
import { App } from './components/App';
import './index.css';

configureHoneybadger();
reloadOnConsentWithdrawal();
removeDeniedCookies();

createRoot(document.getElementById('root') as HTMLElement, {
  onCaughtError: notifyCaughtRenderError,
}).render(<App />);
